module.exports = __webpack_public_path__ + "img/school-project-white.bb01d215.svg";